import { Button, Heading, Stack, Text } from '@chakra-ui/react';
import { Link } from '@tanstack/react-router';
import { type FC } from 'react';

import { Icon, type AvailableIcons } from '$/components/common/Icon';
import { type TypedToOptions } from '$/routes';

interface EmptyStateCardProps {
  title: string;
  description: string;
  buttonText?: string;
  to?: TypedToOptions;
  icon?: AvailableIcons;
  onClick?: () => void;
}

export const EmptyStateCard: FC<EmptyStateCardProps> = ({
  title,
  description,
  buttonText,
  onClick,
  to,
  icon = 'like',
}) => (
  <Stack
    alignItems='center'
    gap='6'
    maxW='32rem'
    p='8'
    bg='bodyBackground'
    border='1px solid'
    borderColor='border'
    borderRadius='12px'
  >
    <Heading as='h2' fontSize='xl' textAlign='center'>
      {title}
    </Heading>
    <Icon icon={icon} boxSize='3rem' />
    <Text fontSize='sm' textAlign='center' whiteSpace='pre-line'>
      {description}
    </Text>
    {to && buttonText && (
      <Button as={Link} to={to} variant='black'>
        {buttonText}
      </Button>
    )}
    {!to && onClick && buttonText && (
      <Button onClick={onClick} variant='black'>
        {buttonText}
      </Button>
    )}
  </Stack>
);
